module.exports = __webpack_public_path__ + "static/media/notfound.e5635514.svg";